import { render, staticRenderFns } from "./FileType.vue?vue&type=template&id=078f85af&scoped=true"
import script from "./FileType.vue?vue&type=script&lang=js"
export * from "./FileType.vue?vue&type=script&lang=js"
import style0 from "./FileType.vue?vue&type=style&index=0&id=078f85af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078f85af",
  null
  
)

export default component.exports